import { TrialCancelledListPage } from "@/features/match/pages/TrialCancelledList";
import React from "react";

const TrialCancelledList = () => {
  return <TrialCancelledListPage />;
};

export default TrialCancelledList;
